import { Link } from "react-router-dom";

// Bootstrap components
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

// Custom styles
import "./footer.styles.scss";

// Assets
import waIconGreen from "../../assets/images/wa-icon--green.svg";
import fbGreenIcon from "../../assets/images/facebook.png";
import igGreenIcon from "../../assets/images/ig-icon.png";
import linkedGreenIcon from "../../assets/images/linkedin-icon.png";
import UNE from "../../assets/images/UNE.png";
import Condusef from "../../assets/images/Condusef.png";
import Buro from "../../assets/images/Buro.png";
import Asofom from "../../assets/images/Asofom.png";
import CNBV from "../../assets/images/CNBV.png";

function Footer() {
  return (
    <footer
      className="footer"
      style={{
        backgroundColor: "#000",
        padding: "3rem 0 1.5rem",
        color: "#fff",
      }}
    >
      <a
        href="https://wa.me/+523331582842"
        className="btn_float"
        target="_blank"
        rel="noreferrer"
      >
        <img src={waIconGreen} alt="WhatsApp AFIX" />
      </a>

      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col-12 col-lg-4 mb-5 mb-lg-0">
            <div className="footer__contact">
              <h6 className="font-weight-bold mb-3">
                <strong>Oficina corporativa</strong>
              </h6>
              <ul
                className="list-unstyled"
                style={{ lineHeight: "1.8", fontSize: "0.9rem" }}
              >
                <li>
                  <a
                    href="https://maps.app.goo.gl/ernUY12YkWS7FZ4n6"
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    <strong>Av. Américas 1930. Piso 10 UP-2</strong>
                    <br />
                    Col. Country Club. C.P. 44610. Guadalajara, Jalisco. MX.
                  </a>
                </li>
                <li className="mt-3">
                  <a
                    href="tel:+523336301888"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    (33)-36-30-18-88
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:hola@afix.com.mx"
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    hola@afix.com.mx
                  </a>
                </li>
              </ul>

              <div className="footer__logos__links mt-4">
                <h6 className="font-weight-bold mb-1">
                  <strong>
                    <Link
                      to="/aviso-de-privacidad"
                      style={{ color: "#fff", textDecoration: "none" }}
                    >
                      Aviso de Privacidad
                    </Link>
                  </strong>
                </h6>
                <h6 className="font-weight-bold mb-0">
                  <strong>
                    <a
                      href="https://webappsos.condusef.gob.mx/EducaTuCartera/consejos.html"
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "#fff", textDecoration: "none" }}
                    >
                      Educación Financiera
                    </a>
                  </strong>
                </h6>
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-5 mb-5 mb-lg-0">
            <h6 className="font-weight-bold mb-4">Regulación y supervisión</h6>
            <div className="footer__logos__container">
              <div
                className="footer__logos d-flex flex-wrap align-items-center"
                style={{ gap: "1.5rem" }}
              >
                <Link to="/unidad-especializada-de-atencion-a-clientes">
                  <img
                    src={UNE}
                    alt="UNE"
                    style={{ height: "25px", objectFit: "contain" }}
                  />
                </Link>
                <Link to="/condusef" className="condusef">
                  <img
                    src={Condusef}
                    alt="Condusef"
                    style={{ width: "90px", objectFit: "contain" }}
                  />
                </Link>
                <img
                  src={Buro}
                  alt="Buro"
                  style={{ height: "35px", objectFit: "contain" }}
                />
                <a
                  href="https://asofom.mx/region-occidente/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={Asofom}
                    alt="Asofom"
                    style={{ height: "30px", objectFit: "contain" }}
                  />
                </a>
                <img
                  src={CNBV}
                  alt="CNBV"
                  style={{ height: "35px", objectFit: "contain" }}
                />
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-3">
            <div className="footer__main">
              <h6 className="font-weight-bold mb-4">Síguenos en redes:</h6>
              <div className="d-flex" style={{ gap: "1rem" }}>
                <a
                  href="https://www.facebook.com/AFIXFinanciera"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={fbGreenIcon}
                    alt="Facebook"
                    style={{ width: "40px" }}
                  />
                </a>
                <a
                  href="https://www.instagram.com/afixfinanciera"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={igGreenIcon}
                    alt="Instagram"
                    style={{ width: "40px" }}
                  />
                </a>
                <a
                  href="https://www.linkedin.com/company/afixfinanciera"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={linkedGreenIcon}
                    alt="LinkedIn"
                    style={{ width: "40px" }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        <hr style={{ borderTop: "1px solid #333", margin: "2rem 0" }} />

        <div
          className="footer__regulatory"
          style={{ fontSize: "0.85rem", color: "#a0a0a0", lineHeight: "1.6" }}
        >
          <p className="font-weight-bold mb-4" style={{ color: "#fff" }}>
            Esta SOFOM se encuentra regulada por la CONDUSEF.
          </p>
          <p className="mb-4">
            <strong style={{ color: "#fff" }}>AFIX SERVICIOS FINACIEROS</strong>
            , al ser una SOFOM E.N.R. y de conformidad al artículo 87-J de la
            Ley General de Organizaciones y Actividades Auxiliares del Crédito,
            no requiere autorización de la Secretaría de Hacienda y Crédito
            Público para su constitución y operación, y está sujeta a la
            supervisión o vigilancia de la Comisión Nacional Bancaria y de
            Valores.
          </p>
          <p className="mb-4">
            <strong style={{ color: "#fff" }}>
              AFIX SERVICIOS FINANCIEROS
            </strong>
            , de acuerdo con el Articulo 95-bis de la Ley General de
            Organizaciones y Actividades Auxiliares del Crédito es vigilada y
            supervisada por la Comisión Nacional Bancaria y de Valores para el
            adecuado cumplimiento de las disposiciones relacionadas con la
            Prevención de Operaciones con Recursos de Procedencia Ilícita y
            Financiamiento al Terrorismo.
          </p>
        </div>

        <hr style={{ borderTop: "1px solid #333", margin: "2rem 0" }} />

        <div
          className="footer__bottom d-flex flex-column flex-md-row justify-content-between text-uppercase"
          style={{ fontSize: "0.75rem", fontWeight: "bold" }}
        >
          <p className="mb-2 mb-md-0">
            TODOS LOS DERECHOS RESERVADOS 2026. AFIX SERVICIOS FINANCIEROS SAPI
            DE C.V. SOFOM ENR
          </p>
          <p className="mb-0">
            DISEÑADO Y DESARROLLADO POR 
            <a
              href="https://www.puntoasterisco.com/"
              target="blank"
            >
              {" "}PUNTOASTERISCO
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
